//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ConfirmTable',
  props: {
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tableRef: null
    };
  },
  computed: {
    tableData: {
      set: function set(val) {
        this.$emit('update:dataSource', val);
      },
      get: function get() {
        return this.dataSource;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.tableRef = _this.$refs.xTable;
    });
  },
  methods: {
    getTableData: function getTableData() {
      return this.tableRef.getTableData();
    },
    getRecordset: function getRecordset() {
      return this.tableRef.getRecordset();
    },
    insert: function insert(row) {
      this.tableRef.insert(row);
    },
    handleDelete: function handleDelete(row, index) {
      var _this2 = this;

      this.$confirm('确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.tableRef.remove(row);
      });
    },
    setCurrentRow: function setCurrentRow(index) {
      this.tableRef.setCurrentRow(this.tableData[index]);
    }
  }
};